/* סיכום תקופה: חלון שנפתח בתחילת תקופה חדשה, וכרטיס בבית כשמסתכלים על תקופה שעברה */
import { fMoney, fmt, wD } from '../../lib/format.js';
import { periodLabel } from '../../domain/periods.js';
import { cat } from '../../domain/categories.js';
import { periodReview } from '../../domain/review.js';
import { Sheet } from '../../components/ui.jsx';
import { openModal } from '../../app/nav.js';
import { openEditTx } from '../transactions/EditTx.jsx';
import { useApp } from '../../store/ui.js';

export function openReview(k) {
  openModal(() => <ReviewSheet k={k} />);
}

function ReviewSheet({ k }) {
  useApp();
  return (
    <Sheet wide title={'סיכום ' + periodLabel(k)}>
      <ReviewBody k={k} />
    </Sheet>
  );
}

const pct = (a, b) => (b > 0 ? Math.round((a / b - 1) * 100) : 0);

export function ReviewBody({ k }) {
  const R = periodReview(k);
  if (!R.hasData) return <div className="empty-s">אין פעולות בתקופה הזו</div>;
  const expVs = R.nPrev ? pct(R.exp, R.avgExp) : null;
  const balMove = R.close != null && R.open != null ? R.close - R.open : null;
  return (
    <div className="review">
      <div className={'callout ' + (R.net >= 0 ? 'ok' : 'warn')} style={{ marginTop: 0 }}>
        <b>{R.net >= 0 ? 'נשארו ' + fMoney(R.net) + ' מעבר להוצאות' : 'יצאו ' + fMoney(Math.abs(R.net)) + ' יותר ממה שנכנס'}</b>
        <div>
          {expVs == null ? 'אין עדיין תקופות קודמות להשוואה.'
            : Math.abs(expVs) < 5 ? 'ההוצאות היו בגובה הרגיל.'
              : expVs > 0 ? 'ההוצאות היו גבוהות ב-' + expVs + '% מהממוצע של ' + R.nPrev + ' התקופות הקודמות.'
                : 'ההוצאות היו נמוכות ב-' + Math.abs(expVs) + '% מהממוצע של ' + R.nPrev + ' התקופות הקודמות.'}
          {R.saved > 0 && ' הועברו ' + fMoney(R.saved) + ' לחיסכון.'}
        </div>
      </div>

      <div className="grid3 mt12">
        <div className="rv-box"><div className="rv-k">הכנסות</div><div className="rv-v green">{fMoney(R.inc)}</div></div>
        <div className="rv-box"><div className="rv-k">הוצאות</div><div className="rv-v red">{fMoney(R.exp)}</div>
          {expVs != null && <div className="rv-s">ממוצע {fMoney(R.avgExp)}</div>}</div>
        <div className="rv-box"><div className="rv-k">{R.close != null ? 'יתרה בסוף' : 'הפרש'}</div>
          <div className="rv-v" style={{ color: (R.close ?? R.net) < 0 ? 'var(--red)' : 'var(--green)' }}>{fMoney(R.close ?? R.net)}</div>
          {balMove != null && <div className="rv-s">{balMove >= 0 ? 'עלתה ב-' : 'ירדה ב-'}{fMoney(Math.abs(balMove))}</div>}</div>
      </div>

      {(R.rising.length > 0 || R.falling.length > 0 || R.nPrev > 0) && (
        <>
          <div className="rv-h">מה בלט מול תקופה רגילה</div>
          {!R.rising.length && !R.falling.length && <div className="note">✓ אף קטגוריה לא חרגה מהרגיל</div>}
          {R.rising.map((x) => {
            const c = cat('expense', x.c);
            return <div key={x.c} className="rv-row"><span>{c.icon} {c.label}</span><span><b>{fMoney(x.v)}</b> <span className="red">▲ {pct(x.v, x.avg)}%</span> <span className="muted">(בדרך כלל {fMoney(x.avg)})</span></span></div>;
          })}
          {R.falling.map((x) => {
            const c = cat('expense', x.c);
            return <div key={x.c} className="rv-row"><span>{c.icon} {c.label}</span><span><b>{fMoney(x.v)}</b> <span className="green">▼ {Math.abs(pct(x.v, x.avg))}%</span> <span className="muted">(בדרך כלל {fMoney(x.avg)})</span></span></div>;
          })}
        </>
      )}

      {R.overBudget.length > 0 && (
        <>
          <div className="rv-h">חריגה מיעד התקציב</div>
          {R.overBudget.map((g) => {
            const c = cat('expense', g.c);
            return <div key={g.c} className="rv-row"><span>{c.icon} {c.label}</span><span><b className="red">{fMoney(g.spent)}</b> <span className="muted">מתוך {fMoney(g.budget)}</span></span></div>;
          })}
        </>
      )}

      <div className="rv-h">ההוצאות הגדולות</div>
      {R.big.map((t) => (
        <div key={t.id} className="rv-row clickable" onClick={() => openEditTx(t.id)}>
          <span className="ellipsis">{cat('expense', t.cat).icon} {t.description} <span className="muted">· {wD(t.date)}</span></span><b>{fmt(t.amount)}</b>
        </div>
      ))}

      <div className="rv-h">לפי קטגוריה</div>
      {R.cats.slice(0, 6).map((x) => {
        const c = cat('expense', x.c), w = R.exp ? (x.v / R.exp) * 100 : 0;
        return (
          <div key={x.c} className="rv-cat">
            <div className="row-b"><span>{c.icon} {c.label}</span><span><b>{fMoney(x.v)}</b> <span className="muted">{Math.round(w)}%</span></span></div>
            <div className="rv-bar"><i style={{ width: Math.max(2, w) + '%', background: c.color }} /></div>
          </div>
        );
      })}
    </div>
  );
}
